module.exports = __webpack_public_path__ + "img/logo-core.1fb13673.png";